export const SHOPPING_ASSISTANT = 'shopping_assistant'
export const SHOPPING_ASSISTANT_NEW = 'shopping_assistant_new'
